import { getDatTime, getDate, getHour, getTime } from './dateUtil';
import { addZero, getTempToWindChill } from './stringUtil';
import { getWeatherByCode, getWeatherIconByLevel, WEATHER_LVL, WEEK_KOR_STR } from './constants';

// 한국어 날씨명 → 아이콘 파일명
export const getWeatherIconForKor = (val) => {
    if (!val) return "none.png";
    if (val === "맑음") return "sun.png";
    if (val === "구름많음") return "cloudy.png";
    if (val === "흐림") return "overcast.png";
    if (val.indexOf("소나기") > -1) return "shower.png";
    if (val.indexOf("비/눈") > -1) return "rainsnow.png";
    if (val.indexOf("눈") > -1) return "snowy.png";
    if (val.indexOf("비") > -1) return "rainy.png";
    return "none.png";
};

// 24시간 시간별 데이터 가공
export const processHourlyData = (timeData) => {
    let todayDataArr = [];
    let minTemp = 100;
    let maxTemp = -100;

    for (let i = 1; i < 25; i++) {
        let dataKey = "D" + getDatTime(i, 'H').substring(0, 10) + "00";
        let item = timeData[dataKey];
        let timeLb = getDatTime(i, 'H').substring(8, 10);
        timeLb = timeLb > 12 ? "오후 " + (parseInt(timeLb) - 12) : "오전 " + parseInt(timeLb);

        let weather = getWeatherByCode(item.SKY, item.PTY);

        if (minTemp > parseInt(item.TMP)) minTemp = parseInt(item.TMP);
        if (maxTemp < parseInt(item.TMP)) maxTemp = parseInt(item.TMP);

        todayDataArr.push({
            key: dataKey,
            temp: parseInt(item.TMP),
            time: timeLb,
            icon: weather.icon,
            rainRate: item.POP
        });
    }

    return { todayDataArr, tempRange: { low: minTemp, max: maxTemp } };
};

// 4일 주간 데이터 가공 (단기예보 기반)
export const processWeeklyFromHourly = (timeData) => {
    let threeDayTemp = {};

    for (let day = 0; day < 4; day++) {
        for (let time = 0; time < 24; time++) {
            let dateKey = "D" + getDate(day, "D");
            let dataKey = "D" + getDate(day, "D") + addZero(time) + "00";
            let item = timeData[dataKey];

            if (item === undefined) continue;
            if (dataKey.indexOf(dateKey) !== 0) continue;

            try {
                if (!threeDayTemp[dateKey]) {
                    threeDayTemp[dateKey] = {
                        rainRate: 0, minTemp: 100, maxTemp: -100,
                        morning: 0, afternoon: 0
                    };
                }

                let dayData = threeDayTemp[dateKey];

                if (day === 0) {
                    dayData.dayStr = "오늘";
                } else {
                    var now = new Date();
                    let dayIdx = now.getDay() + day;
                    dayIdx = dayIdx >= 7 ? dayIdx - 7 : dayIdx;
                    dayData.dayStr = WEEK_KOR_STR[dayIdx] + "요일";
                }

                let weather = getWeatherByCode(item.SKY, item.PTY);
                let weatherType = weather.type;

                if (dayData.rainRate < parseInt(item.POP)) dayData.rainRate = parseInt(item.POP);
                if (dayData.minTemp > parseInt(item.TMP)) dayData.minTemp = parseInt(item.TMP);
                if (dayData.maxTemp < parseInt(item.TMP)) dayData.maxTemp = parseInt(item.TMP);

                let hour = parseInt(dataKey.replace(dateKey, "").substring(0, 2));
                if (hour < 12) {
                    if (dayData.morning < WEATHER_LVL[weatherType]) dayData.morning = WEATHER_LVL[weatherType];
                } else {
                    if (dayData.afternoon < WEATHER_LVL[weatherType]) dayData.afternoon = WEATHER_LVL[weatherType];
                }

                threeDayTemp[dateKey] = dayData;
            } catch (e) { }
        }
    }

    let weekDataArr = new Array(4);
    for (let day = 0; day < 4; day++) {
        let dataKey = "D" + getDate(day, "D");
        if (!threeDayTemp[dataKey]) continue;
        threeDayTemp[dataKey].morning = getWeatherIconByLevel(threeDayTemp[dataKey].morning);
        threeDayTemp[dataKey].afternoon = getWeatherIconByLevel(threeDayTemp[dataKey].afternoon);
        weekDataArr[day] = threeDayTemp[dataKey];
    }
    return weekDataArr;
};

// 중기예보 데이터 가공 (daily forecast 기반)
export const processDailyData = (data) => {
    let weekDataArr = new Array(3);
    for (let i = 0; i < data.length; i++) {
        let item = data[i];
        let dayData = {};

        var now = new Date();
        let dayIdx = now.getDay() + item.day;
        dayIdx = dayIdx >= 7 ? dayIdx - 7 : dayIdx;
        dayData.dayStr = WEEK_KOR_STR[dayIdx] + "요일";

        dayData.rainRate = item.rainRate;
        dayData.minTemp = item.minTemp;
        dayData.maxTemp = item.maxTemp;
        dayData.morning = getWeatherIconForKor(item.morning);
        dayData.afternoon = getWeatherIconForKor(item.afternoon);

        weekDataArr[i] = dayData;
    }
    return weekDataArr;
};

// WeatherItem에서 시간 기반 날씨 키 결정
export const resolveWeatherTimeKey = (data, target) => {
    let isNextDay = data.startHour + data.startMinute > data.destHour + data.destMinute;

    if (getHour() <= addZero(data.startHour)) {
        if (target === "start") {
            return "D" + getDate() + addZero(data.startHour) + "00";
        } else {
            if (isNextDay) {
                return "D" + getDate(1, 'D') + addZero(data.destHour) + "00";
            } else {
                return "D" + getDate() + addZero(data.destHour) + "00";
            }
        }
    } else if (getHour() >= addZero(data.destHour)) {
        if (target === "start") {
            return "D" + getDate(1, "D") + addZero(data.startHour) + "00";
        } else {
            return "D" + getDate(1, "D") + addZero(data.destHour) + "00";
        }
    } else {
        if (target === "start") {
            if (data.startHour >= "2300") {
                return "D" + getDate(1, "H") + "0000";
            } else {
                return "D" + getDate() + getTime(1, "H").substring(0, 2) + "00";
            }
        } else {
            let key;
            if (data.destHour >= "2300") {
                key = "D" + getDate(1, "H") + "0000";
            } else {
                key = "D" + getDate() + addZero(data.destHour) + "00";
            }
            if (isNextDay) {
                key = "D" + getDate(1, 'D') + addZero(data.destHour) + "00";
            }
            return key;
        }
    }
};

// 강수량 포맷
export const formatPrecipitation = (weatherData) => {
    let weather = getWeatherByCode(weatherData.SKY, weatherData.PTY);
    let precipitation = "";

    if (weatherData.PCP !== "강수없음") {
        precipitation = weatherData.PCP;
    }
    if (weather.type === "Snow") {
        precipitation = weatherData.SNO;
    }
    if (precipitation !== "") {
        precipitation = precipitation.replaceAll("mm", "㎜");
        precipitation = precipitation.replaceAll("cm미만", "㎝↓");
        precipitation = precipitation.replaceAll("cm", "㎝");
    }
    return { ...weather, precipitation };
};

// 날씨 리포트 집계
export const buildWeatherReport = (weatherDataArr, list) => {
    let startTime = "2359";
    let destTime = "0000";

    if (list && list.length > 0) {
        for (let i in list) {
            if (list[i].startHour + list[i].startMinute < startTime) {
                startTime = list[i].startHour + list[i].startMinute;
            }
            if (list[i].destHour + list[i].destMinute > destTime) {
                destTime = list[i].destHour + list[i].destMinute;
            }
        }
    }

    let conditionLv = 0, isRain = false, isShower = false;
    let precipitation = "", snowfall = "";
    let minTemp = "", maxTemp = "", humidity = "", windSpeed = "", rainRate = "", windChill = "";

    for (let i in weatherDataArr) {
        let item = weatherDataArr[i];
        let prefix = item.destDate ? "dest" : "start";

        if (i === "0") {
            conditionLv = WEATHER_LVL[item[prefix + "Weather"]];
            minTemp = parseInt(item[prefix + "Temp"]);
            maxTemp = parseInt(item[prefix + "Temp"]);
            humidity = item[prefix + "Humidity"];
            windSpeed = item[prefix + "WindSpeed"];
            rainRate = item[prefix + "RainRate"];
            windChill = getTempToWindChill(minTemp, windSpeed);
            if (item[prefix + "Weather"] === "Snow") {
                snowfall = item[prefix + "Precipitation"];
            } else {
                precipitation = item[prefix + "Precipitation"];
            }
        } else {
            if (conditionLv < WEATHER_LVL[item[prefix + "Weather"]]) {
                conditionLv = WEATHER_LVL[item[prefix + "Weather"]];
            }
            if (item[prefix + "Weather"] === "Snow") {
                if (snowfall < item[prefix + "Precipitation"]) snowfall = item[prefix + "Precipitation"];
            } else {
                if (precipitation < item[prefix + "Precipitation"]) precipitation = item[prefix + "Precipitation"];
            }
            if (minTemp > parseInt(item[prefix + "Temp"])) minTemp = parseInt(item[prefix + "Temp"]);
            if (maxTemp < parseInt(item[prefix + "Temp"])) maxTemp = parseInt(item[prefix + "Temp"]);
            if (humidity < item[prefix + "Humidity"]) humidity = item[prefix + "Humidity"];
            if (windSpeed < item[prefix + "WindSpeed"]) windSpeed = item[prefix + "WindSpeed"];
            if (rainRate < item[prefix + "RainRate"]) rainRate = item[prefix + "RainRate"];
            if (windChill > getTempToWindChill(minTemp, windSpeed)) windChill = getTempToWindChill(minTemp, windSpeed);
        }

        if (WEATHER_LVL[item[prefix + "Weather"]] >= 3) isRain = true;
        if (WEATHER_LVL[item[prefix + "Weather"]] === 5) isShower = true;
    }

    return {
        conditionLv, precipitation, snowfall,
        minTemp, maxTemp, humidity, windSpeed,
        startTime, destTime, isRain, isShower, rainRate, windChill,
        date: getDate(), time: getTime()
    };
};
